function text(value) {
  return value === null || value === undefined ? '' : String(value).trim()
}

export function normalizeCatalog(value) {
  if (!Array.isArray(value)) return null
  if (value.some((row) => !row || typeof row !== 'object' || Array.isArray(row))) return null

  const normalized = value.map((row) => ({
    codigo: Number(row.codigo),
    descricao: text(row.descricao),
    unidade_saude_codigo: Number(row.unidade_saude_codigo),
    ativo: row.ativo,
    razao_social: text(row.razao_social)
  }))

  return normalized.every((row) =>
    Number.isInteger(row.codigo) &&
    Number.isInteger(row.unidade_saude_codigo) &&
    row.descricao &&
    row.razao_social &&
    (row.ativo === true || row.ativo === null)
  ) ? normalized : null
}

export function catalogDecision(rows) {
  if (!rows.length) return 'empty'
  return rows.length === 1 ? 'single' : 'multiple'
}

export function groupCatalog(rows, search = '') {
  const term = text(search).toLocaleLowerCase('pt-BR')
  const filtered = rows.filter((row) => !term || [
    row.codigo,
    row.descricao,
    row.razao_social
  ].some((value) => String(value).toLocaleLowerCase('pt-BR').includes(term)))

  const groups = new Map()
  for (const row of filtered) {
    if (!groups.has(row.razao_social)) groups.set(row.razao_social, [])
    groups.get(row.razao_social).push(row)
  }

  return [...groups.entries()]
    .sort(([left], [right]) => left.localeCompare(right, 'pt-BR'))
    .map(([razao_social, paineis]) => ({
      razao_social,
      paineis: paineis.sort((left, right) =>
        left.descricao.localeCompare(right.descricao, 'pt-BR') || left.codigo - right.codigo)
    }))
}
